import React from 'react';
import { Box, Theme, useMediaQuery, useTheme } from '@mui/material';
import * as routes from '@educabot/educablocks-cosmos';

interface Props {
  kit: 'starter-kit' | 'automation-kit' | 'driving-kit';
}
export const ImageKit: React.FC<Props> = ({ kit }) => {
  const muiTheme = useTheme();
  const isMdSize = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Box
      bgcolor="white"
      borderRadius={(theme) => ({ xs: theme.spacing(1.5), md: theme.spacing(5) })}
      marginTop={{ xs: '0.875rem', md: '2.5rem' }}
      sx={{
        width: '100%',
        maxWidth: '1080px',
        marginX: 'auto',
      }}
    >
      <img
        style={{
          width: '100%',
          height: 'auto',
          maxHeight: '600px',
          objectFit: 'contain',
          borderRadius: isMdSize ? muiTheme.spacing(5) : muiTheme.spacing(1.5),
        }}
        src={`${routes.bloquesUri}/images/creabots/landing/${kit}/kit.png`}
        alt="Ilustración del packaging del kit de iniciación"
      />
    </Box>
  );
};
